import { ControlledInput, ExtranetContainer } from '@pharmac-extranet/shared'
import {
  PharmacButton,
  PharmacFieldset,
  PharmacFieldsetLegend,
  PharmacIcon,
  PharmacText,
  PharmacTooltip,
} from '@pharmac/ui'
import { Control, FieldValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useAuthenticationContext } from '../../features/authentication/useAuthentication'
import { ConfirmationModal } from '../confirmation-modal/ConfirmationModal'
import { useResetApiKey } from './useResetApiKey'
export const ResetApiKeyInput = () => {
  const { t } = useTranslation()
  const {
    isPharmacy,
    showConfirmationModal,
    showPassword,
    copyToClipboard,
    handleReset,
    isAdmin,
    formHook,
    setShowConfirmationModal,
  } = useResetApiKey()
  const { isPharmacCustomerService } = useAuthenticationContext()

  if (!isPharmacy) return null

  return (
    <PharmacFieldset marginLarge>
      <PharmacFieldsetLegend>
        <ExtranetContainer
          flexRow
          alignCenter
          justifyStart
        >
          {t('customer.ordersApiKeyTitle')}
          <PharmacTooltip
            marginSmallLeft
            position="top-end"
            handle={
              <PharmacIcon
                icon="info"
                style={{
                  color: 'var(--color-green)',
                  marginRight: 'var(--spacing-tiny)',
                  marginTop: 'var(--spacing-tiny)',
                }}
              />
            }
          >
            {t('customer.ordersApiKeyTooltip')}
          </PharmacTooltip>
        </ExtranetContainer>
      </PharmacFieldsetLegend>
      <ExtranetContainer
        flexColumn
        full
      >
        <ExtranetContainer full>
          <div
            style={{
              fontFamily: 'var(--font-family-secondary)',
              paddingBottom: 'var(--spacing-large)',
              paddingLeft: 'var(--spacing-tiny)',
              paddingRight: 'var(--spacing-tiny)',
            }}
          >
            {t('customer.ordersApiKeyDisclaimer')}
          </div>
        </ExtranetContainer>
        <ExtranetContainer full>
          <ControlledInput
            readOnly
            name="apiKey"
            control={formHook.control as unknown as Control<FieldValues>}
            type={showPassword ? 'text' : 'password'}
            disabled={!isAdmin || isPharmacCustomerService}
          />
        </ExtranetContainer>
        <ExtranetContainer
          full
          flexRow
          justifyStart
          marginMediumTop
        >
          <PharmacButton
            marginSmallRight
            disabled={!isAdmin || isPharmacCustomerService}
            onClick={() => setShowConfirmationModal(true)}
          >
            <PharmacText weight="bold">{t('customer.ordersApiKeyResetButton')}</PharmacText>
            <PharmacIcon
              style={{ marginLeft: 'var(--spacing-small)' }}
              icon="repeat"
              size="16"
            />
          </PharmacButton>
          <PharmacButton
            variant="secondary"
            onClick={copyToClipboard}
            disabled={!showPassword || !isAdmin || isPharmacCustomerService}
          >
            <PharmacText weight="bold">{t('customer.ordersApiKeyCopyToClipboard')}</PharmacText>
            <PharmacIcon
              style={{ marginLeft: 'var(--spacing-small)' }}
              icon="copy"
              size="16"
            />
          </PharmacButton>
        </ExtranetContainer>
      </ExtranetContainer>
      <ConfirmationModal
        showOnProp={showConfirmationModal}
        title={t('customer.ordersApiKeyModalTitle')}
        onSubmit={handleReset}
        closeButtonText={t('cancel', { ns: 'common' })}
        submitButtonText={t('customer.ordersApiKeyModalOkButton')}
        onClose={() => setShowConfirmationModal(false)}
        content={
          <ExtranetContainer>
            <PharmacText>{t('customer.ordersApiKeyModalDisclaimer')}</PharmacText>
          </ExtranetContainer>
        }
      />
    </PharmacFieldset>
  )
}
